import { styled } from 'linaria/react';

import { FONTS } from '../../../styles/constants';

// --- Card wrapper (simplified, no isPlainCard) ---

export const StyledWrapper = styled.div<{ colorValue?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
  color: ${({ colorValue }) => colorValue ?? 'inherit'};
`;

// --- Card container (simplified, no isPlainCard/borderColor) ---

export const StyledContainer = styled.div`
  color: inherit;
  box-sizing: border-box;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  cursor: pointer;
`;

// --- Image wrapper with media-category classes ---

export const StyledImageWrap = styled.div`
  border-radius: 8px;
  overflow: hidden;
  width: 100%;

  &.loading {
    min-height: 200px;
  }

  img {
    border-radius: 8px;
    width: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }

  &.landscape img {
    height: auto;
  }

  &.square {
    max-height: 260px;

    img {
      max-height: 260px;
    }
  }

  &.portrait {
    max-height: 320px;

    img {
      max-height: 320px;
    }
  }

  &.verticalVideo {
    height: 256px;

    img {
      max-height: 320px;
    }
  }
`;

// --- Text-only card (bordered, no image) ---

export const StyledTextCard = styled.div<{ borderColor: string }>`
  border: 1px solid ${({ borderColor }) => borderColor};
  border-radius: 10px;
  padding: 24px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
`;

export const StyledEyebrow = styled.span`
  font: 400 12px/140% ${FONTS.secondary};
  text-transform: capitalize;
  text-align: center;
`;

export const StyledSourceText = styled.span`
  font: 400 12px/140% ${FONTS.secondary};
  opacity: 0.6;
  text-align: center;
`;

// --- Title (center-aligned, 3-line clamp) ---

export const StyledCenteredTitle = styled.div`
  font: 400 18px/140% ${FONTS.primary};
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  padding: 0 12px;
  width: 100%;
  box-sizing: border-box;
`;

// --- Comment row ---

export const StyledCommentRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  max-width: 342px;
  width: 100%;
  box-sizing: border-box;
`;

export const StyledCommentAvatar = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: cover;
`;

export const StyledCommentText = styled.span`
  font: 550 14px/140% ${FONTS.secondary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  max-width: 250px;
`;

// --- Reaction button trigger ---

export const StyledReactionTrigger = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 20px;
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: inherit;
  flex-shrink: 0;
`;

// --- Action buttons ---

export const StyledActionButtons = styled.div`
  display: flex;
  gap: 2px;
  align-items: center;
  justify-content: center;
`;

export const StyledActionButton = styled.button`
  padding: 6px;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  color: inherit;
`;

// --- Card content stack (gap between image/text-card and metadata) ---

export const StyledCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  width: 100%;
`;

export const StyledMetadata = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  width: 100%;
`;
